import React from "react";

/**
 * GenderCard
 * Shows the gender distribution (% and absolute count) for one gender group,
 * with a progress bar visualising the ratio against the total.
 */
const GenderCard = ({
  title,
  count,
  total,
  icon,
}) => {
  const percent = total > 0 ? Math.round((count / total) * 100) : 0;

  return (
    <div className="bg-white border border-slate-100/80 rounded-2xl p-4 flex flex-col justify-between h-full hover:shadow-sm transition-all duration-200">
      <div>
        <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-[#1D1F3F] text-white">
          {icon}
        </div>
        <p className="text-xs font-bold text-[#1d1f3f] uppercase tracking-wider mt-3 font-display">
          {title}
        </p>
        <p className="text-4xl font-extrabold text-slate-900 tracking-tight mt-1 font-display">
          {percent}%
        </p>
        <p className="text-xs sm:text-sm font-semibold text-slate-400 mt-2 font-display">
          {count} de {total} Colaboradores
        </p>

        <div className="mt-3.5 mb-1 space-y-2">
          <div className="w-full h-1.5 bg-slate-200 rounded-full overflow-hidden">
            <div
              className="h-full rounded-full transition-all duration-500 bg-[#1D1F3F]"
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenderCard;
